import { Component } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatDialogRef } from '@angular/material/dialog'
import { TimeCardStatus } from '../../../../api/models/timecard.model'

export interface TimesheetsResetDialogResult {
    timecardResetStatus: TimeCardStatus
}

@Component({
    selector: 'ppw-timesheets-reset-dialog',
    templateUrl: './timesheets-reset-dialog.component.html',
    styleUrls: ['./timesheets-reset-dialog.component.scss']
})
export class TimesheetsResetDialogComponent {
    protected readonly TimeCardStatus = TimeCardStatus

    timecardResetStatusControl: FormControl<TimeCardStatus> = new FormControl<TimeCardStatus>(TimeCardStatus.EDITED, {
        nonNullable: true
    })

    constructor(
        private readonly dialogRef: MatDialogRef<TimesheetsResetDialogComponent, TimesheetsResetDialogResult>
    ) {}

    confirm(): void {
        this.dialogRef.close({
            timecardResetStatus: this.timecardResetStatusControl.value
        })
    }
}
